import { render } from "./NavComponent.vue?vue&type=template&id=0565602c&scoped=true"
import script from "./NavComponent.vue?vue&type=script&lang=js"
export * from "./NavComponent.vue?vue&type=script&lang=js"

import "./NavComponent.vue?vue&type=style&index=0&id=0565602c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0565602c"]])

export default __exports__